/* OS Listicle - Proof Blocks Carousel */
(() => {
  const SELECTOR_ROOT = '[data-os-listicle-proof-carousel]';

  function buildDots(root, track, slides) {
    const dotsWrap = root.querySelector('[data-os-listicle-proof-dots]');
    if (!dotsWrap || !track || !slides.length) return;

    dotsWrap.innerHTML = '';

    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'os-listicle-proof-reviews__dot';
      dot.setAttribute('aria-label', `Go to review ${index + 1}`);

      dot.addEventListener('click', () => {
        slide.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      });

      dotsWrap.appendChild(dot);
    });

    const dots = Array.from(dotsWrap.querySelectorAll('.os-listicle-proof-reviews__dot'));

    const setActiveDot = () => {
      if (window.innerWidth > 989) {
        dots.forEach((dot) => dot.classList.remove('is-active'));
        return;
      }

      const trackRect = track.getBoundingClientRect();
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const distance = Math.abs(rect.left - trackRect.left);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === closestIndex);
      });
    };

    track.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(setActiveDot);
      },
      { passive: true }
    );

    window.addEventListener('resize', setActiveDot);
    setActiveDot();
  }

  function initSection(root) {
    if (!root || root.__osListicleProofBound) return;
    root.__osListicleProofBound = true;

    const track = root.querySelector('[data-os-listicle-proof-track]');
    const slides = track ? Array.from(track.querySelectorAll('[data-os-listicle-proof-slide]')) : [];

    if (!track || !slides.length) return;

    buildDots(root, track, slides);
  }

  function init() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState !== 'loading') {
    init();
  }
})();